// @flow
import { createStore, applyMiddleware } from "redux";

import domainsReducer from "./domains/reducer";
import timerReducer from "./timer/reducer";
import settingsReducer from "./settings/reducer";

declare var chrome: any;

function AppReducer(state = {}, action) {
	return {
		domains: domainsReducer(state.domains, action),
		timer: timerReducer(state.timer, action),
		settings: settingsReducer(state.settings, action),
	};
}

// This allows the various parts of the chrome extension to keep their redux
// stores in sync
const syncStoresMiddleware = (store) => (next) => (action) => {
	// We don't want to send the sync message if the action was triggered by
	// a sync message from another part of the app
	if (!action.IS_SYNC_ACTION) {
		chrome.runtime.sendMessage(
			{
				type: "syncStore",
				config: {
					action: {
						IS_SYNC_ACTION: true,
						...action,
					},
				},
			},
			() => {}
		);
	}

	// Trigger the reducers
	let result = next(action);
	return result;
};

export default function getStore(initial_state: any) {
	var store = createStore(
		AppReducer,
		initial_state,
		applyMiddleware(syncStoresMiddleware)
	);

	// Persist state to localStorage
	store.subscribe(() => {
		let current_state = store.getState();
		chrome.runtime.sendMessage(
			{
				type: "saveState",
				config: {
					app_state: {
						domains: {
							domains: current_state.domains.domains.map((domain) => {
								return {
									site: domain.site,
								};
							}),
						},
						settings: current_state.settings,
					},
				},
			},
			() => {}
		);
	});

	return store;
}



// WEBPACK FOOTER //
// ../shared/store/index.js